import Table from "components/DataTable/Table";
import React, { useEffect, useState } from "react";
import { Await, Link } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import ShipmentMethodsAdd from "./shipmentMethodsAdd";
import ShipmentMethodsUpdate from "./shipmentMethodsUpdate";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import Spinner from "components/Spinner";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";

function ShipmentMethods() {
  const user = useSelector((state) => state.user.userInfo);
  /*   All States Below
   ********************************************* */
  const [shipmentMethods, setShipmentMethods] = useState(null);
  const [lastSortId, setLastSortId] = useState(null);

  // Modals
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // below update data is used to set a varible before moving to update component
  const [updateData, setUpdateData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState();

  /*   All Functions Below
   ********************************************* */

  // get All shipmentMethods
  const getAllShipmentMethods = async () => {
    try {
      const { data } = await API.get("/shipmentmethods", {
        headers: authHeader(),
      });
      setShipmentMethods(data);

      setLastSortId(
        data[data.length - 1]?.sortId ? data[data.length - 1]?.sortId : 0
      );
    } catch (err) {
      alert(err.message);
    }
  };

  // Delete password Data
  const deleteShipmentMethodsData = async (id) => {
    const { data } = await API.delete("/shipmentmethods/delete/" + id, {
      headers: authHeader(),
    });
    if (data.message.type == "success") {
      getAllShipmentMethods();
      return;
    }
  };

  // Sorting Up
  const sortUp = async (index) => {
    const currentSortId = shipmentMethods[index].sortId;
    const currentId = shipmentMethods[index].id;
    const upSortId = shipmentMethods[index - 1].sortId;
    const upId = shipmentMethods[index - 1].id;
    try {
      const { data } = await API.post(
        "/shipmentmethods/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        getAllShipmentMethods();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (index) => {
    const currentSortId = shipmentMethods[index].sortId;
    const currentId = shipmentMethods[index].id;
    const downSortId = shipmentMethods[index + 1].sortId;
    const downId = shipmentMethods[index + 1].id;
    try {
      const { data } = await API.post(
        "/shipmentmethods/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        getAllShipmentMethods();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const setDefaultShipmentMethod = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.post(
        "/shipmentmethods/set-default",
        { id },
        { headers: authHeader() }
      );
      if (data.success) {
        await getAllShipmentMethods();
      }
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllShipmentMethods();
  }, []);

  /*   Table Functions below
   ********************************************* */
  const buttons = () => (
    <div className="d-flex justify-content-end ms-2">
      <button onClick={() => setShowAddModal(true)} className="btn btn-primary">
        ADD NEW
      </button>
    </div>
  );

  const table_head = ["Shipment Methods", "Is Default", "Actions"];
  const table_body = (item, index) => (
    <tr key={item.id}>
      <td>{item.shippingMethod}</td>
      <td>{item.isDefault ? "Yes" : "No"}</td>
      <td className="table-action text-end">
        {!item?.isDefault && (
          <button
            onClick={() => setDefaultShipmentMethod(item.id)}
            className="btn btn-info btn-sm py-0 px-2 fs-5"
          >
            Set Default
          </button>
        )}
        {user?.roles === "admin" && (
          <button
            onClick={() => {
              item.sortId != 1 && sortUp(index);
            }}
            className="action-icon btn btn-sm border-0"
          >
            <i className="mdi mdi-chevron-double-up"></i>
          </button>
        )}
        {user?.roles === "admin" && (
          <button
            onClick={() => {
              item.sortId != shipmentMethods.length && sortDown(index);
            }}
            className="action-icon btn btn-sm border-0"
          >
            <i className="mdi mdi-chevron-double-down"></i>
          </button>
        )}
        <button className="action-icon btn btn-sm border-0">
          <i
            onClick={() => {
              setShowUpdateModal(true);
              setUpdateData(item);
            }}
            className="mdi mdi-pencil"
          ></i>
        </button>
        <DeleteModalButton
          deleteFunc={deleteShipmentMethodsData}
          deleteParams={item.id}
          btnClass={"action-icon btn btn-sm border-0"}
        />
      </td>
    </tr>
  );

  return (
    <div className="row">
      <h3>Shipment Methods</h3>
      {loading && <Spinner />}
      <div className="col-12">
        <Table
          btn1={buttons}
          table_body={table_body}
          table_data={shipmentMethods}
          table_head={table_head}
          actionsOnEnd={true}
          columnSortable={false}
        />

        {/*   ADD Modal
         ********************************************* */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
          <Modal.Body className="custom-shadow">
            <div>
              <ShipmentMethodsAdd
                showAddPage={setShowAddModal}
                refreshFunc={getAllShipmentMethods}
                lastSortId={lastSortId}
              />
            </div>
          </Modal.Body>
        </Modal>
        {/*   Update Modal
         ********************************************* */}
        <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
          <Modal.Body className="custom-shadow">
            <div>
              <ShipmentMethodsUpdate
                data={updateData}
                showUpdatePage={setShowUpdateModal}
                refreshFunc={getAllShipmentMethods}
              />
            </div>
          </Modal.Body>
        </Modal>
        {/*   Confirmation Modal
         ********************************************* */}

        <div
          id="danger-alert-modal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm ">
            <div className="modal-content modal-filled bg-danger">
              <div className="modal-body p-4">
                <div className="text-center">
                  <i className="ri-close-circle-line h1"></i>
                  <h4 className="mt-2">Confirm Delete!</h4>
                  <p className="mt-3">Do You want to delete ?</p>
                  <button
                    type="button"
                    className="btn btn-light my-2 mx-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-light my-2 "
                    data-bs-dismiss="modal"
                    onClick={() => {
                      deleteShipmentMethodsData(selectedDelete.id);
                    }}
                  >
                    DELETE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShipmentMethods;
